import Lookup from '../components/forms/Lookup'

const Index = () => <Lookup />
Index.displayName = 'OrderLookup';
Index.getLayout = page => page

export default Index
